import { render, staticRenderFns } from "./configuracoes.vue?vue&type=template&id=30474314&scoped=true&"
import script from "./configuracoes.vue?vue&type=script&lang=js&"
export * from "./configuracoes.vue?vue&type=script&lang=js&"
import style0 from "./configuracoes.vue?vue&type=style&index=0&id=30474314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30474314",
  null
  
)

export default component.exports